<template>
    <b-form @submit.prevent="onSubmit">
        <div class="auth">
            <div class="auth-title">{{ $t('auth.reset_password') }}</div>
            <div class="auth-body">
                <div class="w-100">
                    <b-alert :show="message.text" :variant="message.status">
                        <div v-html="message.text"></div>
                    </b-alert>
                    <div class="form-group">
                        <b-form-input id="password" v-model="form.password" type="password"
                                      :state="validation.password.valid"
                                      :placeholder="$t('auth.new_password')"
                                      required></b-form-input>
                        <b-form-invalid-feedback :state="validation.password.valid">
                            {{ validation.password.message }}
                        </b-form-invalid-feedback>
                    </div>
                    <div class="form-group">
                        <b-form-input id="password-confirmation" v-model="form.password_confirmation" type="password"
                                      :placeholder="$t('auth.confirm_password')"
                                      :state="validation.password_confirmation.valid"
                                      required></b-form-input>
                        <b-form-invalid-feedback :state="validation.password_confirmation.valid">
                            {{ validation.password_confirmation.message }}
                        </b-form-invalid-feedback>
                    </div>
                    <div class="d-flex">
                        <router-link :to="i18nLink('login')" class="btn btn-link mr-2 text-dark text-uppercase">
                            {{ $t('auth.back_to_login') }}
                        </router-link>
                        <button type="submit" class="btn btn-primary btn-shadow ml-auto text-uppercase">
                            {{ $t('auth.reset_password') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </b-form>
</template>

<script>
  import resetPassword from 'src/mixins/resetPasswordComponent';

  export default {
    mixins: [resetPassword],
  };
</script>
